/**
 * loader.js
 * Handles early page readiness: waits for critical fonts and then marks the document
 * to reveal content while fading out the loader.
 */
const Loader = {
  init(options = {}) {
    const root = document.documentElement;
    const timeout = options.timeout || 2500;
    let done = false;
    const loaderEl = document.querySelector('.loader');
    if (loaderEl) {
      loaderEl.setAttribute('role','status');
      loaderEl.setAttribute('aria-live','polite');
      loaderEl.setAttribute('aria-label','Loading content');
    }

    function finalize() {
      // Add class to html so inline style reveals content
      root.classList.add('app-ready');
      if (loaderEl) {
        // Use CSS visibility/opacity transition then remove
        loaderEl.classList.add('is-hidden');
        loaderEl.setAttribute('aria-hidden','true');
        setTimeout(() => {
          if (loaderEl && loaderEl.parentNode) {
            loaderEl.parentNode.removeChild(loaderEl);
          }
        }, 500); // matches transition duration
      }
    }

    function mark() {
      if (done) return;
      done = true;
      finalize();
    }

    try {
      if (document.fonts && document.fonts.ready) {
        Promise.all([
          document.fonts.ready,
          document.fonts.load('1rem "Netflix Sans"'),
          document.fonts.load('700 1rem "Netflix Sans Black"'),
          document.fonts.load('1rem "Didot"')
        ]).then(mark).catch(mark);
      } else {
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
          requestAnimationFrame(mark);
        } else {
          document.addEventListener('DOMContentLoaded', mark, { once: true });
        }
      }
    } catch (e) {
      mark();
    }
    setTimeout(mark, timeout);
  }
};

export default Loader;
